export default [
    'GMT -12',
    'GMT -11',
    'GMT -10',
    'GMT -9:30',
    'GMT -9',
    'GMT -8:30',
    'GMT -8',
    'GMT -7',
    'GMT -6',
    'GMT -5',
    'GMT -4',
    'GMT -3:30',
    'GMT -3',
    'GMT -2',
    'GMT -1',
    'GMT Z',
    'GMT +1',
    'GMT +2',
    'GMT +3',
    'GMT +3:30',
    'GMT +4',
    'GMT +4:30',
    'GMT +5',
    'GMT +5:30',
    'GMT +6',
    'GMT +6:30',
    'GMT +7',
    'GMT +8',
    'GMT +9',
    'GMT +9:30',
    'GMT +10',
    'GMT +10:30',
    'GMT +11',
    'GMT +11:30',
    'GMT +12'
];


// WEBPACK FOOTER //
// ./app/data/gmt.js